import { render, staticRenderFns } from "./OrganizationPlans.vue?vue&type=template&id=6864eb0a&scoped=true&"
import script from "./OrganizationPlans.vue?vue&type=script&lang=js&"
export * from "./OrganizationPlans.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationPlans.vue?vue&type=style&index=0&id=6864eb0a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6864eb0a",
  null
  
)

export default component.exports